<template>
	<Modal @close="$emit('close')" :draggable="false">
		<template slot="title">Return Box</template>
		<template slot="body">
			<div style="width: 1200px; height: 750px;">
				<div class="half_tbl_box">
					<div class="left_tbl" style="height: 720px;">
						<table>
							<tr>
								<td class="al_right">
									<a href="javascript:void(0);" class="gray_bt" @click="severalLabelPrint('ALL')">Print All</a>
									<a href="javascript:void(0);" class="search_bt mgr_10" @click="insertReturnBox()">Add Box</a>
								</td>
							</tr>
						</table>

						<div class="fixed-table-container-none-padding">
							<h4 class="inner_h5">Continued Ruturn Box List</h4>
							<div class="table-wrapper" style="height: 39%; margin-bottom: 10px;">
								<table id="item_list" class="list_tbl sticky_list_tbl">
									<colgroup>
										<col style="width: 50px;" />
										<col style="width: 50px;" />
										<col style="width: 80px;" />
										<col />
										<col style="width: 100px;" />
										<col style="width: 80px;" />
									</colgroup>
									<thead>
										<tr>
											<th>Ord.</th>
											<th>Qty.</th>
											<th><a href="javascript:void(0);" class="gray_bt" @click="severalLabelPrint('CONTINUE')">Print</a></th>
											<th>Packer</th>
											<th>Crt.DT</th>
											<th>Del.</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(rb, i) in continued_box_list" :key="i" @click="findSelectedBox(rb.return_box_no)" :class="{ on: selected_box.return_box_no === rb.return_box_no }">
											<td class="al_right">{{ rb.display_order_no }}</td>
											<td class="al_right">{{ rb.quantity | commaSeparated }}</td>
											<td class="al_center" @click.stop><a href="javascript:void(0);" class="gray_bt" @click="labelPrint(rb.return_box_no)">Print</a></td>
											<td class="al_left">{{ rb.crt_name }}</td>
											<td class="al_center">{{ rb.crt_dt }}</td>
											<td class="al_center" @click.stop><a href="javascript:void(0);" class="gray_bt" @click="deleteReturnBox(rb.return_box_no)">Del.</a></td>
										</tr>
									</tbody>
								</table>
							</div>

							<h4 class="inner_h5">Discontinued Ruturn Box List</h4>
							<div class="table-wrapper" style="height: 29%; margin-bottom: 10px;">
								<table id="item_list" class="list_tbl sticky_list_tbl">
									<colgroup>
										<col style="width: 50px;" />
										<col style="width: 50px;" />
										<col style="width: 80px;" />
										<col />
										<col style="width: 100px;" />
										<col style="width: 80px;" />
									</colgroup>
									<thead>
										<tr>
											<th>Ord.</th>
											<th>Qty.</th>
											<th><a href="javascript:void(0);" class="gray_bt" @click="severalLabelPrint('DISCONTINUE')">Print</a></th>
											<th>Packer</th>
											<th>Crt.DT</th>
											<th>Del.</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(rb, i) in discontinued_box_list" :key="i" @click="findSelectedBox(rb.return_box_no)" :class="{ on: selected_box.return_box_no === rb.return_box_no }">
											<td class="al_right">{{ rb.display_order_no }}</td>
											<td class="al_right">{{ rb.quantity | commaSeparated }}</td>
											<td class="al_center" @click.stop><a href="javascript:void(0);" class="gray_bt" @click="labelPrint(rb.return_box_no)">Print</a></td>
											<td class="al_left">{{ rb.crt_name }}</td>
											<td class="al_center">{{ rb.crt_dt }}</td>
											<td class="al_center" @click.stop><a href="javascript:void(0);" class="gray_bt" @click="deleteReturnBox(rb.return_box_no)">Del.</a></td>
										</tr>
									</tbody>
								</table>
							</div>

							<div class="table-wrapper" style="height: 29%;">
								<table v-if="selected_box.return_box_no" class="view_tbl">
									<colgroup>
										<col style="width: 25%;" />
										<col style="width: 25%;" />
										<col style="width: 25%;" />
										<col style="width: 25%;" />
									</colgroup>
									<tbody>
										<tr>
											<th>Order No.</th>
											<td class="al_right">
												<currency-input type="text" style="width: 100px;" v-model.trim="display_order_no" :precision="0" :valueRange="{ min: 0 }" class="int_type al_right" @focus="$event.target.select()" />
											</td>
											<td colspan="2">
												<a href="javascript:void(0);" class="gray_bt" @click="applyOrder()">Apply</a>
											</td>
										</tr>
										<tr>
											<th>Quantity</th>
											<td class="al_right">
												<input type="text" style="width: 100px;" v-model.trim="selected_box.quantity" :precision="0" class="int_type al_right" :disabled="true" />
											</td>
											<td class="al_right">
												<label>
													<input type="checkbox" v-model="selected_box.discontinued" @change="changeDiscontinued()" />
													<span>Discontinue</span>
												</label>
											</td>
											<td></td>
										</tr>
										<tr>
											<th>UPS Code</th>
											<td colspan="3" class="al_right">
												<input type="text" v-model.trim="selected_box.box_dn" class="tbl_int" placeholder="Barcode Scan" @focus="$event.target.select()" />
											</td>
										</tr>
										<tr>
											<th>Memo</th>
											<td colspan="3" class="al_right">
												<input type="text" v-model.trim="selected_box.memo" class="tbl_int" placeholder="" @focus="$event.target.select()" />
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="right_tbl" style="height: 720px;">
						<div class="fixed-table-container-none-padding">
							<h4 class="inner_h5">Unpacked Item List</h4>
							<div class="table-wrapper" style="height: 45%; margin-bottom: 10px;">
								<table id="item_list" class="list_tbl sticky_list_tbl">
									<colgroup>
										<col style="width: 50px;" />
										<col style="width: 80px;" />
										<col />
										<col style="width: 20px;" />
										<col style="width: 20px;" />
										<col style="width: 80px;" />
										<col style="width: 50px;" />
									</colgroup>
									<thead>
										<tr>
											<th>Loc.</th>
											<th>Rack/Sec</th>
											<th>Class</th>
											<th></th>
											<th><input ref="allCheckBox" type="checkbox" @change="selectAll()" /></th>
											<th>Color</th>
											<th>Unp.</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(unpack, index) in unpacked_item_list" :key="unpack.invoice_item_no" @dblclick="addToBoxItems(unpack)" :class="{ bg_gray: !unpack.unpacked_quantity }">
											<td class="al_center">{{ unpack.location_code }}</td>
											<td class="al_center">{{ unpack.rack }}-{{ unpack.section }}</td>
											<td class="truncate" :title="unpack.class_code">
												<span v-if="unpack.class_closed_yn === 'Y'" style="font-weight: bold; color: red;">!!</span><span>{{ unpack.class_code }}</span>
											</td>
											<td @dblclick.stop><input ref="classCheckBox" v-if="index === 0 || unpack.class_code !== unpacked_item_list[index - 1].class_code" type="checkbox" @change="selectClassAll(index)" /></td>
											<td @dblclick.stop><input type="checkbox" v-model="unpack.selected" /></td>
											<td class="truncate" :title="unpack.color_code">{{ unpack.color_code }}</td>
											<td class="al_right">{{ unpack.unpacked_quantity | commaSeparated }}</td>
										</tr>
									</tbody>
								</table>
							</div>

							<h4 class="inner_h5" style="position: relative;">
								<span style="vertical-align: sub;">Item List in Selected Box</span>
								<a href="javascript:void(0);" class="gray_bt mgr_10" style="position: absolute; top: 3px; right: 0px;" @click="clearBox()">Clear</a>
							</h4>
							<div class="table-wrapper" style="height: 40%; margin-bottom: 10px;">
								<table class="list_tbl sticky_list_tbl" :key="selected_box_item_list_key">
									<thead>
										<tr>
											<th style="width: 50px;">Loc.</th>
											<th style="width: 80px;">Rack/Sec</th>
											<th>Class</th>
											<th style="width: 80px;">Color</th>
											<th style="width: 50px;">Qty</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in selected_box.box_item_list" :key="item.invoice_item_no" @dblclick="calcQuantity(item, 0)">
											<td class="al_center">{{ item.location_code }}</td>
											<td class="al_center">{{ item.rack }}-{{ item.section }}</td>
											<td class="truncate" :title="item.class_code">
												<span v-if="item.class_closed_yn === 'Y'" style="font-weight: bold; color: red;">!!</span><span>{{ item.class_code }}</span>
											</td>
											<td class="truncate" :title="item.color_code">{{ item.color_code }}</td>
											<td class="al_right" @dblclick.stop>
												<currency-input
													type="text"
													style="width: 40px;"
													:value="item.item_quantity"
													:valueRange="{ min: 0 }"
													:precision="0"
													class="int_type al_right"
													@blur="calcQuantity(item, $event.target.value)"
													@focus="$event.target.select()"
												/>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div style="margin-bottom: 10px;">
								<table>
									<tr>
										<td class="al_right">
											<a href="javascript:void(0);" class="search_bt" @click="updateReturnBoxItemBatch()">Save</a>
											<a href="javascript:void(0);" class="gray_bt mgr_10" @click="$emit('close')">Close</a>
										</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="popup_bottom"></div> -->
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import { apiSelectReturnBoxList, apiInsertReturnBox, apiUpdateReturnBox, apiDeleteReturnBox, apiUpdateReturnBoxItemBatch } from '@/api/sales/boxing.js';
import { apiSelectInvoiceItemList } from '@/api/sales/boxing.js';
import { apiGetReportTemplate, reportMrtUrl, Report, getMrtFile, PrintType } from '@/api/util';
import { objectCopy } from '@/api/util.js';
export default {
	data: () => ({
		return_box_list: [],
		continued_box_list: [],
		discontinued_box_list: [],
		selected_box: {},

		// Invoice Item List
		invoice_item_list: [],
		unpacked_item_list: [],

		display_order_no: null,
		selected_box_item_list_key: 0, // current-input 태그는 event.target.value에 값을 대입하여도 event.target.value가 변하지 않음.
	}),
	components: {
		Modal,
	},
	props: {
		invoice_no: {
			type: Number,
		},
	},
	methods: {
		resetCheckBox() {
			this.$refs.allCheckBox.checked = false;
			this.$refs['classCheckBox'].forEach(el => (el.checked = false));
			this.unpacked_item_list.forEach(el => (el.selected = false));
		},
		selectAll() {
			const checked = event.target.checked;
			this.unpacked_item_list.forEach(el => (el.selected = checked));
		},
		selectClassAll(index) {
			const checked = event.target.checked;
			const class_code = this.unpacked_item_list[index].class_code;

			for (let i = index; i < this.unpacked_item_list.length; i++) {
				if (this.unpacked_item_list[i].class_code === class_code) {
					this.unpacked_item_list[i].selected = checked;
				} else {
					break;
				}
			}
		},
		async labelPrint(return_box_no) {
			const param = { invoice_no: this.invoice_no, return_box_no, for_boxing: true };
			const now_dt = this.$moment(new Date());
			const { data } = await apiSelectReturnBoxList(param);
			if (!Array.isArray(data) || !data.length || !Array.isArray(data[0].box_item_list)) {
				this.$toast.error('No Items to be Shown.');
				return;
			}

			const root = {
				invoice_no: this.invoice_no,
				scan_date: now_dt.format('MM-DD-YYYY'),
				scan_time: now_dt.format('HH:mm:ss'),
				items: data[0].box_item_list,
				display_order_no: data[0].order_no,
				discontinued: data[0].discontinued,
				ship_to_code: data[0].ship_to_code,
			};

			const reportTemplate = await apiGetReportTemplate('ReturnLabel', reportMrtUrl('ReturnLabel'));
			const report = new Report(reportTemplate, root, 'ReturnLabel');
			this.$store.commit('setReport', report);
		},
		async severalLabelPrint(mode) {
			const param = { invoice_no: this.invoice_no, for_boxing: true };
			if (mode === 'DISCONTINUE') param.discontinue_only = true;
			else if (mode === 'CONTINUE') param.continue_only = true;

			const now_dt = this.$moment(new Date());
			const { data } = await apiSelectReturnBoxList(param);
			if (!Array.isArray(data) || !data.length) {
				this.$toast.error('No Items to be Shown.');
				return;
			}

			const roots = [];
			data.forEach(rb => {
				roots.push({
					invoice_no: this.invoice_no,
					scan_date: now_dt.format('MM-DD-YYYY'),
					scan_time: now_dt.format('HH:mm:ss'),
					items: rb.box_item_list || [],
					display_order_no: rb.order_no,
					discontinued: rb.discontinued,
					ship_to_code: rb.ship_to_code,
				});
			});

			const reportTemplate = await getMrtFile(reportMrtUrl('ReturnLabel'));
			const report = new Report(reportTemplate, roots, 'ReturnLabel', PrintType.List);
			this.$store.commit('setReport', report);
		},
		findMaxOrderNumber(discontinued) {
			return this.return_box_list.filter(rb => !!rb.discontinued === !!discontinued).length;
		},
		changeDiscontinued() {
			this.display_order_no = this.findMaxOrderNumber(this.selected_box.discontinued);
			this.applyOrder();
		},
		applyOrder() {
			let max_num = this.findMaxOrderNumber(this.selected_box.discontinued);

			if (this.display_order_no < 1) {
				this.display_order_no = this.selected_box.display_order_no;
				this.$toast.error('Enter a Number Greater than 1.');
				return;
			} else if (this.display_order_no > max_num) {
				this.display_order_no = this.selected_box.display_order_no;
				this.$toast.error('Enter a Number less than ' + max_num + '.');
				return;
			}

			const idx = this.return_box_list.indexOf(this.selected_box);
			if (idx < 0) return;

			const shift_left = this.selected_box.display_order_no > this.display_order_no;
			for (let i = 0; i < this.return_box_list.length; i++) {
				if (i === idx) continue;

				const rb = this.return_box_list[i];
				if (shift_left && this.display_order_no <= rb.display_order_no && rb.display_order_no < this.selected_box.display_order_no) {
					rb.display_order_no++;
				} else if (!shift_left && this.selected_box.display_order_no < rb.display_order_no && rb.display_order_no <= this.display_order_no) {
					rb.display_order_no--;
				}
			}
			this.selected_box.display_order_no = this.display_order_no;

			// display_order_no로 1차 정렬
			this.return_box_list.sort((a, b) => a.display_order_no - b.display_order_no);
			// discontinued로 2차 정렬
			this.return_box_list.sort((a, b) => !!b.discontinued - !!a.discontinued);

			this.makeDisplayOrderNo(this.return_box_list);
		},
		makeDisplayOrderNo(rb_list) {
			const discontinued_list = rb_list.filter(rb => rb.discontinued);
			const continued_list = rb_list.filter(rb => !rb.discontinued);
			discontinued_list.forEach((rb, i) => (rb.display_order_no = i + 1));
			continued_list.forEach((rb, i) => (rb.display_order_no = i + 1));

			this.discontinued_box_list = discontinued_list;
			this.continued_box_list = continued_list;
		},
		clearBox() {
			while (this.selected_box.box_item_list.length > 0) this.calcQuantity(this.selected_box.box_item_list[0], 0);
		},
		setSelectedBoxQuantity() {
			this.selected_box.quantity = this.selected_box.box_item_list.reduce((prev, curr) => prev + curr.item_quantity, 0);
		},
		calcQuantity(item, new_value) {
			if (typeof new_value === 'string') new_value = Number(new_value.trim() || '0');
			else if (typeof new_value !== 'number') return;
			// const input = event.target.value.trim() || '0';
			const old_value = item.item_quantity;

			item.item_quantity = new_value;
			let refresh_selected_box_item_list = false;
			const invoice_item = this.invoice_item_list.find(ii => ii.invoice_item_no === item.invoice_item_no);
			const shipped_qty = invoice_item.quantity_abs;
			let packing_qty = this.getPackedQuantity(item.invoice_item_no);
			if (shipped_qty < packing_qty) {
				item.item_quantity = old_value;
				// packing_qty 재계산
				packing_qty = this.getPackedQuantity(item.invoice_item_no);
				refresh_selected_box_item_list = true;
				// this.selected_box_item_list_key++;
				this.$toast.error('Over Quantity.');
			}

			const unpack = this.unpacked_item_list.find(ui => ui.invoice_item_no === item.invoice_item_no);
			unpack.unpacked_quantity = shipped_qty - packing_qty;

			if (item.item_quantity < 1) {
				const idx = this.selected_box.box_item_list.findIndex(rbi => rbi.invoice_item_no === item.invoice_item_no);
				if (idx > -1) this.selected_box.box_item_list.splice(idx, 1);
			} else if (refresh_selected_box_item_list) {
				this.selected_box_item_list_key++;
			}

			this.setSelectedBoxQuantity();
		},
		getPackedQuantity(invoice_item_no) {
			let packing_qty = 0;
			this.return_box_list.forEach(rb => {
				if (Array.isArray(rb.box_item_list)) {
					packing_qty = rb.box_item_list.filter(rbi => rbi.invoice_item_no === invoice_item_no).reduce((prev, curr) => (prev += curr.item_quantity), packing_qty);
				}
			});

			return packing_qty;
		},
		addToBoxItems(unpack) {
			if (!unpack.selected) {
				this.packingItem(unpack);
			} else {
				this.unpacked_item_list.filter(el => el.selected).forEach(el => this.packingItem(el));
				this.resetCheckBox();
			}
		},
		packingItem(unpack) {
			if (!unpack.unpacked_quantity) {
				this.$toast.error('No Balance.');
				return;
			}

			const item = this.selected_box.box_item_list.find(rbi => rbi.invoice_item_no === unpack.invoice_item_no);
			if (item) {
				const new_value = item.item_quantity + unpack.unpacked_quantity;
				this.calcQuantity(item, new_value);
			} else {
				const box_item = objectCopy(unpack);
				box_item.return_box_no = this.selected_box.return_box_no;
				box_item.item_quantity = unpack.unpacked_quantity;
				unpack.unpacked_quantity = 0;

				this.selected_box.box_item_list.push(box_item);
			}

			this.setSelectedBoxQuantity();
		},
		makeUnpackedItemList() {
			const unPackedList = [];
			this.invoice_item_list.forEach(item => {
				const shipped_qty = item.quantity_abs;
				const packing_qty = this.getPackedQuantity(item.invoice_item_no);
				const unpacked_quantity = shipped_qty - packing_qty;

				unPackedList.push({
					invoice_item_no: item.invoice_item_no,
					item_id: item.item_id,
					item_name: item.name,
					class_code: item.class_code,
					color_code: item.color_code,
					unpacked_quantity: unpacked_quantity > 0 ? unpacked_quantity : 0,
					location_code: item.location_code,
					rack: item.rack,
					section: item.section,
					class_closed_yn: item.class_closed_yn,
					selected: false,
				});
			});

			this.unpacked_item_list = unPackedList;
		},
		selectRow(idx) {
			if (this.return_box_list && this.return_box_list.length) {
				this.selected_box = this.return_box_list[idx];
				if (!this.selected_box.box_item_list) this.selected_box.box_item_list = [];
			} else {
				this.selected_box = {
					box_item_list: [],
					return_box_no: null,
					order_no: null,
				};
			}

			this.display_order_no = this.selected_box.display_order_no;
		},
		findSelectedBox(return_box_no) {
			let idx = 0;
			if (return_box_no) {
				idx = this.return_box_list.findIndex(rb => rb.return_box_no === return_box_no);
				if (idx < 0) idx = 0;
			}

			this.selectRow(idx);
		},
		async selectItemList() {
			const { data } = await apiSelectInvoiceItemList(this.invoice_no, true);
			this.invoice_item_list = data;
		},
		async selectReturnBoxList(return_box_no) {
			const param = { invoice_no: this.invoice_no, for_boxing: true };
			const { data } = await apiSelectReturnBoxList(param);
			this.makeDisplayOrderNo(data);
			this.return_box_list = data;

			this.makeUnpackedItemList();
			this.findSelectedBox(return_box_no);
		},
		async insertReturnBox() {
			const param = {
				invoice_no: this.invoice_no,
				quantity: 0,
			};
			const { data } = await apiInsertReturnBox(param);
			this.return_box_list.push(data);
			this.makeDisplayOrderNo(this.return_box_list);
			this.findSelectedBox(data.return_box_no);
			this.$toast.success('Add Return Box.');
		},
		async updateReturnBox() {
			// 사용 안함.
			const { data } = await apiUpdateReturnBox(this.selected_box);
			this.$toast.success('Modify Return Box.');
			this.selectReturnBoxList(data);
		},
		async deleteReturnBox(return_box_no) {
			const tmp_return_box_no = this.selected_box.return_box_no;
			this.findSelectedBox(return_box_no);
			this.clearBox();

			const { data } = await apiDeleteReturnBox({ return_box_no, invoice_no: this.invoice_no });
			const idx = this.return_box_list.findIndex(rb => rb.return_box_no === data);
			if (idx > -1) {
				this.return_box_list.splice(idx, 1);
				this.makeDisplayOrderNo(this.return_box_list);
			}
			this.$toast.success('Delete Return Box.');
			this.findSelectedBox(tmp_return_box_no);
		},
		async updateReturnBoxItemBatch() {
			if (!this.return_box_list || !this.return_box_list.length) {
				this.$toast.error('No Return Box to Save.');
				return;
			}

			this.return_box_list.forEach(rb => (rb.order_no = rb.display_order_no));
			// 선택된 return_box_no를 파라미터로 넘겨준 후, 다른 Update코드와 마찮가지로 return_box_no를 return 받음.
			let param = { return_box_list: this.return_box_list, return_box_no: this.selected_box.return_box_no || 0 };
			const { data } = await apiUpdateReturnBoxItemBatch(param);
			this.$toast.success('Modify Return Box.');
			this.selectReturnBoxList(data);
		},
		async init() {
			await this.selectItemList();
			await this.selectReturnBoxList(0);
		},
	},
	created() {
		this.init();
	},
	beforeDestroy() {
		// 사용 안함.
		// apiArrangeReturnBoxOrder({ invoice_no: this.invoice_no });
	},
};
</script>

<style></style>
